// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menuItem--2cdZMcOO {\n  display: flex;\n  align-items: center;\n  color: rgba(137, 137, 137, 0.8);\n  font-size: 14px;\n}\n\nhtml[data-theme=\"dark-v2\"] .menuItem--2cdZMcOO {\n    color: var(--color-normal-text);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuItem": "menuItem--2cdZMcOO"
};
export default ___CSS_LOADER_EXPORT___;
